import type { SideNavigationItem } from './navigation-items.interfaces';
import Tooltip, { type TooltipProps } from '../../tooltip-component/tooltip.component';

interface NavigationItemTooltipProps extends Partial<TooltipProps> {
  item: SideNavigationItem;
}

export const NavigationItemTooltip = ({ item, children, ...props }: NavigationItemTooltipProps) => {
  const badgeTooltipStyles = 'odin-bg-mono-1 odin-overflow-y-auto odin-max-h-1/2 custom-scroll';

  return (
    <Tooltip
      {...props}
      description={item?.badge?.badgeNumber ? item.badge.description : item.label}
      lazyLoadDescription={item?.badge?.lazyLoad}
      closeTooltipOnClick={item?.badge?.closeTooltipOnClick}
      tooltipTransitionDuration={300}
      tooltipClassName={badgeTooltipStyles}
      dependOnChildren={true}
      debounceTime={0}
      wrapperClassName="odin-pr-1 odin-flex odin-items-center sm:odin-py-1"
      tooltipZIndexCheck
    >
      {children}
    </Tooltip>
  );
};
